import React from 'react';
import { createContext, useContext, useState } from 'react';
import { ConfirmationAction } from './types/confirmation-action';

export interface IConfirmationContext {
    action: ConfirmationAction;
    showConfirmation: (action: ConfirmationAction) => string;
    closeConfirmation: () => void;
}

export const ConfirmationContext = createContext<IConfirmationContext>(null!);

export function ConfirmationProvider(props: React.PropsWithChildren<unknown>) {
    const [action, setAction] = useState<ConfirmationAction>();

    const showConfirmation = (action: ConfirmationAction) => {
        setAction(action);
    };

    const closeConfirmation = () => {
        setAction(undefined);
    };

    const contextValue = {
        action,
        showConfirmation,
        closeConfirmation,
    } as IConfirmationContext;

    return <ConfirmationContext.Provider value={{ ...contextValue }}>{props.children}</ConfirmationContext.Provider>;
}

export function useConfirmation() {
    const context = useContext(ConfirmationContext);

    if (!context) {
        throw new Error('useConfirmation must be used within the ConfirmationProvider');
    }

    return context;
}
